import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { EstablishListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { createInitialEstablishList } from '../../logics/establish/createInitialEstablishList';

/**
 * 設立年数に関するhooks
 * @param args
 * @returns 表示用配列と更新処理
 */
export const useEstablish = (args: HooksArgument) => {
  const [establishList, setEstablishList] = useState<EstablishListType[]>(
    createInitialEstablishList(args)
  );

  const selectedEstablishList = useMemo(() => {
    return establishList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  }, [establishList]);

  // チェック状態更新処理
  const updateIsCheckedEstablishList = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const checkedList = establishList.map((item) => {
        if (item.value !== event.target.value) return item;

        return {
          ...item,
          isChecked: event.target.checked,
        };
      });

      setEstablishList(checkedList);

      return checkedList
        .filter(({ isChecked }) => isChecked)
        .map(({ value }) => value);
    },
    [establishList]
  );

  // 求人件数更新処理
  const updateEstablishListJobCount = useCallback(
    (requirementsJobCountList: JobCountDetailResponse[] | undefined) => {
      setEstablishList((pre) =>
        pre.map((item) => ({
          ...item,
          jobCount: findJobCount(requirementsJobCountList, item.value),
        }))
      );
    },
    []
  );

  return {
    establishList,
    selectedEstablishList,
    updateIsCheckedEstablishList,
    updateEstablishListJobCount,
  };
};
